export class ApproveRequest {

        "studyId": Number;
        "mobileNumber": Number;
        "userId": Number;
        "patientId": Number;
        "testValue": String;
        "fileURL": String;
}
